<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
            items.bind="selectedObjectService.selectedObject.write_right"
            objecttypetoadd.bind="'write_right'"
            sortable.bind="'true'"
    >
    </parent-child-select>
</template>
